<template lang="html">
  <div  :style="{ 'padding-top': offsetHeight + 'px' }">
    <van-nav-bar
      :fixed="true"
      title="回复我的评论"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      ref="navBar"
    />
    <CommentList
      :reply-to-me="true"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import CommentList from '../../comment-list.vue'
  Vue.use(NavBar)
  export default {
    components: {
      CommentList
    },
    data () {
      return {
        slug: '',
        offsetHeight: 0
      }
    },
    methods: {
      onClickLeft() {
        this.$router.replace({
          name: `PersonalIndex`,
          params: {
            slug: this.slug
          }
        })
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
      this.$nextTick(function() {
        // this.offsetHeight = this.$refs.navBar.offsetHeight
        this.offsetHeight = this.$refs.navBar.$el.offsetHeight
      })
    }
  }
</script>

<style lang="css" scoped>
</style>
